import { Eye } from "lucide-react"

import { Avatar } from "@/components/tuw/Avatar"

// The strip above the header of an order someone else shared with you (AU-44).
// It names the owner and says plainly what this view is for, so the missing
// buttons read as intended rather than as a broken page. Renders nothing for
// the order's own customer.
export default function SharedViewStrip({ viewer }) {
  if (!viewer?.readOnly) return null

  const owner = viewer.sharedBy?.name ?? "the project owner"
  const initials = viewer.sharedBy?.initials ?? "?"

  return (
    <div
      role="note"
      className="mb-[14px] flex flex-wrap items-center gap-x-[11px] gap-y-1.5 rounded-xl border border-border bg-secondary px-[18px] py-3 text-[13px] text-muted-foreground max-[560px]:px-4"
    >
      <Eye className="size-4 shrink-0 text-ink-3" strokeWidth={1.9} />
      <span className="inline-flex items-center gap-[7px]">
        <Avatar initials={initials} name={owner} size={20} />
        <span>
          Shared with you by <b className="font-semibold text-foreground">{owner}</b>
        </span>
      </span>
      <span className="size-[3px] rounded-full bg-line-2 max-[560px]:hidden" />
      <span>You can follow this project here, but only {owner} can act on it.</span>
    </div>
  )
}
